import { CalendarTranslateService } from './../../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { KontableComponent } from "../../../../../modules/UIKit/components/kontable/kontable.component";
import { Card } from "../../../../../models/loyalty-card.model";
import { LoyaltyCardService } from "../../../../../services/loyalty/loyalty-card.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-card-selection-table',
  templateUrl: './card-selection-table.component.html',
  styleUrls: ['./card-selection-table.component.css']
})
export class CardSelectionTableComponent implements OnInit {

  @Input() cardNo;
  @Input() channelId;
  @Input() flgBlkLst;
  @Input() hideCustomerInfoPermission;
  @Output() onCardSelect: EventEmitter<Card> = new EventEmitter();
  @ViewChild('tablePT') tablePT: any;

  newDataAvailable = false;
  paginationType = KontableComponent.ServerPagination;
  customerItems: Card[];
  initialFilters = [];
  show = {
    datatable: false
  }
  customFilter = KontableComponent.CustomFilter;
  dateFilter = KontableComponent.DateFilter;
  noFilter = KontableComponent.NoFilter;
  selectFilter = KontableComponent.SelectFilter;
  maxChars: number;
  blackListType = [];

  constructor(
    public svcCard: LoyaltyCardService,
    public srvCalTranslate: CalendarTranslateService,
    private translateService: TranslateService
  ) {
    this.maxChars = +sessionStorage.getItem('cardsLength');
  }

  ngOnInit() {
    console.log(this.initialFilters);
    if (this.cardNo) {
      this.initialFilters.push({ key: 'card_no', value: this.cardNo })
    }
    if (this.channelId) {
      this.initialFilters.push({ key: 'channel_id', value: this.channelId })
    }
    if (this.flgBlkLst) {
      this.initialFilters.push({ key: 'flg_blk_lst', value: this.flgBlkLst })
    }


    this.translateService.get([
      'common.all',
      'report.inBlacklist',
      'report.active',
    ]).subscribe(translations => {
      this.blackListType = [
        { label: translations['common.all'], value: null },
        { label: translations['report.inBlacklist'], value: "1" },
        { label: translations['report.active'], value: "0" },

      ];
      this.show.datatable = true;
    });

  }

  ngAfterViewInit() {
    if (this.cardNo) {
      this.tablePT.refresh();
      this.initialFilters.forEach(filter => {
        if (filter.key === 'card_no') {
          this.tablePT.filter.search.card_no = this.cardNo;
        }
      });
    }
    /*
      Se presente filtro iniziale per nascondere carte in blacklist,
      rimuovo il filtro dalla relativa colonna
    */
    if (this.flgBlkLst === '0') {
      this.tablePT.columns.forEach(col => {
        if (col.field === 'flg_blk_lst') {
          Object.assign(col, { filterType: this.noFilter });
        }
      })
    }
  }

  _onCardSelect(data: Card) {
    this.onCardSelect.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/widget/customer-card-search/card-selection-table/card-selection-table.component.ts